import { Services } from '@sigma-frontend-libs/commons'
import { PUBLIC_FIELDS_USER } from '@sigma-legacy-libs/essentials/lib/constants'

import { fillDependence, permissionPresets, serviceTemplate } from '@/utils'

export default {
  mixins: [
    serviceTemplate({
      serviceName: Services.tokens,

      async inputFilter(result) {
        if (!result.Owner) {
          await fillDependence.call(this, result, {
            service: Services.users,
            permissions: permissionPresets.resellerUp,
            pathToId: 'OwnerId',
            pathToObject: 'Owner',
            outputPath: 'Owner',
            picks: PUBLIC_FIELDS_USER
          })
        }

        result.OwnerId = result.Owner && result.Owner.id || result.OwnerId

        return result
      },

      find: {
        defaultFilter: {
          id: undefined,
          OwnerId: undefined
        },
        defaultPagination: { limit: 12 }
      },

      has: {
        clone: false,
        tabs: false
      },

      formClass: '',
      width: 400
    })
  ]
}
